/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues } from '../types/utils';
import { InvestmentStatusChangeLogEntry } from './investment-status-change-log-entry-model';
import { PaymentID } from './payment-model';
import { SaleID } from './sale-model';
import { UserID } from './user-model';

export type InvestmentID = string;

export class Investment {
	id: InvestmentID = ''

	amountShares: number = 0

	awareFees?: boolean

	createdAt?: Date

	paymentId: PaymentID = ''

	saleId: SaleID = ''

	status?: InvestmentStatusValues

	statusChangeLog?: Array<InvestmentStatusChangeLogEntry>

	tac: number = 0

	updatedAt?: Date

	userId: UserID = ''
}